import { render } from "./DashbordIndex.vue?vue&type=template&id=367dfde8"
import script from "./DashbordIndex.vue?vue&type=script&lang=js"
export * from "./DashbordIndex.vue?vue&type=script&lang=js"

import "./DashbordIndex.vue?vue&type=style&index=0&id=367dfde8&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__